<script lang="ts">
  import { onMount, getContext } from "svelte";
  import {
    PlanTier,
    getPlanBaseCost,
  } from "../../../../../../app/store/store-plan";
  import { getPlanTierIcon } from "../../../utils";
  import Icon from "../../../../../common/icons/Icon.svelte";
  import { registerElement } from "../../../../../common/key-control/listKeyControl";
  import type {
    RegisterElementOptions,
    KeyControlConfig,
  } from "../../../../../common/key-control/listKeyControl";
  import type { CreateNewAccountContext } from "../../../type";
  import { CREATE_NEW_ACCOUNT_CONTEXT_NAME } from "../../../utils";

  export let planTier: PlanTier;
  export let changePlanTier: (v: PlanTier) => void;
  export let index: number;
  export let keyControlList: KeyControlConfig[];

  const context: CreateNewAccountContext = getContext(
    CREATE_NEW_ACCOUNT_CONTEXT_NAME
  );
  let pages = context.pages;
  let planCost: number;
  let isSelected: boolean = false;
  let options: RegisterElementOptions = {
    config: {
      isSelected: false,
      index,
      onSelectCallback,
      onDeselectCallback,
    },
    configList: keyControlList,
    index,
  };

  function onSelectCallback() {
    isSelected = true;
  }

  function onDeselectCallback() {
    isSelected = false;
  }

  function handleKeyDown(event: KeyboardEvent) {
    if (event.key === "Enter" && isSelected) {
      handleSelectOption();
    }
  }

  function handleSelectOption() {
    changePlanTier(planTier);
  }

  onMount(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });

  $: if ($pages) {
    planCost = getPlanBaseCost(
      context.getAccountType(),
      planTier,
      context.getPlanDuration()
    );
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class="flex flex-row items-center mx-1.5 h-10 pl-[18px] space-x-2 rounded cursor-pointer"
  class:selected={isSelected}
  use:registerElement={options}
  on:click={handleSelectOption}
>
  <Icon icon={getPlanTierIcon(planTier)} size="20px" />

  <div>
    <span class="text-dark-200 capitalize">{planTier}</span>
    <span class="text-dark-50">(${planCost})</span>
  </div>
</div>

<style lang="postcss">
  .selected {
    @apply bg-light-50;
  }
</style>
